function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9223 15.9721L17.9289 16.595L18.2483 17.1043H16.9238V0.590927H11.8134V3.26825H9.04816V0.590927H3.93781V3.73727H0V18.2769H18.2483L17.9289 18.7862L18.9223 19.4091L20 17.6906L18.9223 15.9721ZM11.8134 4.44075V6.79848L10.5113 7.79889L9.04816 6.90733V4.44075H11.8134ZM5.11036 1.76344H7.87562V6.19282L6.3105 5.2391L5.11036 6.2489V1.76344ZM1.17255 17.1043V4.90977H3.93781V7.23548L2.18801 8.70774L2.9429 9.60493L3.93777 8.76785V17.1043H1.17255ZM5.11036 17.1043V7.78131L6.42033 6.67915L7.87562 7.56595V17.1043H5.11036ZM9.04816 17.1043V8.28046L10.5879 9.21873L11.8134 8.27718V17.1043L9.04816 17.1043ZM12.986 17.1043V7.37627L14.9629 5.85739L14.2485 4.9276L12.986 5.89761V1.76344H15.7512V17.1043H12.986Z",
  fill: "#23335B"
});

var SvgProms = function SvgProms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/proms.22cfff66.svg";
export { ForwardRef as ReactComponent };